import React from 'react';
import { aniosGA11, primerDiaAnio, type InformeGA11 } from '../lib/ga11-anios';
import { informesSinFecha } from '../lib/ga07-meses';
import { hoyISO } from '../lib/sso-documentos';
import './MesesGA07.css';
import './AniosGA11.css';

// Fila de años de GA-11 (bloque 7, B2; ítem 103), con los estilos de la fila de
// meses de GA-07. Verde = hay informe con "Aprobado desde" en ese año (se abre);
// gris = falta (abre Subir con el 1 de enero de ese año).
export default function AniosGA11({ informes, onAbrir, onSubir, hoy = hoyISO() }: {
  informes: InformeGA11[];
  onAbrir: (informe: InformeGA11) => void;
  /** Sin esta función (no puede subir) los años que faltan no se pueden tocar. */
  onSubir?: (aprobadoDesde: string) => void;
  hoy?: string;
}) {
  const anios = aniosGA11(informes, hoy);
  const sinFecha = informesSinFecha(informes);
  return (
    <div className="ga07-meses">
      <div className="ga07-meses-cabecera">
        <span className="ga07-meses-titulo">Informes anuales</span>
      </div>
      <div className="ga07-meses-fila ga11-anios-fila" role="group" aria-label="Informes GA-11 por año">
        {anios.map(a => {
          const tocable = a.estado === 'con_informe' || !!onSubir;
          const titulo = a.estado === 'con_informe' ? `${a.anio}: informe subido. Abrir.`
            : onSubir ? `${a.anio}: falta el informe. Subir.` : `${a.anio}: falta el informe`;
          return (
            <button
              key={a.anio}
              type="button"
              className={`ga07-mes ga07-mes-${a.estado}`}
              disabled={!tocable}
              title={titulo}
              aria-label={titulo}
              onClick={() => {
                if (a.informe) onAbrir(a.informe);
                else onSubir?.(primerDiaAnio(a.anio));
              }}
            >
              {a.anio}
            </button>
          );
        })}
      </div>
      <p className="ga07-meses-nota">
        Verde: hay un informe con "Aprobado desde" en ese año. Gris: falta.
        {sinFecha > 0 && ` ${sinFecha} informe${sinFecha === 1 ? '' : 's'} sin "Aprobado desde" no se cuenta${sinFecha === 1 ? '' : 'n'} (complétalo con Editar).`}
      </p>
    </div>
  );
}
